(function(){
  if(window.__ebkInit)return;window.__ebkInit=true;
  function pad(n){return(n<10?'0':'')+n}
  function run(){
    var src=document.querySelector('[data-ebk-end]');
    var offers=document.querySelectorAll('.ebk-offer');
    var raw=src?src.getAttribute('data-ebk-end'):'';
    var after=src?src.getAttribute('data-ebk-after'):'';
    document.querySelectorAll('[data-ebk-after-text]').forEach(function(e){e.textContent=after||''});
    if(!raw){offers.forEach(function(o){o.hidden=true});return;}
    var end=new Date(raw.length<=10?raw+'T23:59:59':raw);
    if(isNaN(end)){offers.forEach(function(o){o.hidden=true});return;}
    if(!after)document.querySelectorAll('.ebk-after').forEach(function(o){o.hidden=true});
    document.querySelectorAll('.ebk-enddate').forEach(function(el){el.textContent=end.toLocaleDateString('es-ES',{day:'numeric',month:'long'})});
    var iv;
    function tick(){
      var d=end-new Date();
      if(d<=0){offers.forEach(function(o){o.hidden=true});if(iv)clearInterval(iv);return;}
      var D=Math.floor(d/864e5),H=Math.floor(d/36e5)%24,M=Math.floor(d/6e4)%60,S=Math.floor(d/1e3)%60;
      document.querySelectorAll('[data-d]').forEach(function(e){e.textContent=pad(D)});
      document.querySelectorAll('[data-h]').forEach(function(e){e.textContent=pad(H)});
      document.querySelectorAll('[data-m]').forEach(function(e){e.textContent=pad(M)});
      document.querySelectorAll('[data-s]').forEach(function(e){e.textContent=pad(S)});
      document.querySelectorAll('[data-short]').forEach(function(e){e.textContent=(D>0?D+'d ':'')+pad(H)+':'+pad(M)+':'+pad(S)});
    }
    tick();iv=setInterval(tick,1000);
  }
  function sticky(){
    var s=document.getElementById('ebk-sticky'),t=document.getElementById('ebk-top');
    if(!s)return;
    if(!t){s.classList.add('on');return;}
    if('IntersectionObserver' in window){new IntersectionObserver(function(e){s.classList.toggle('on',!e[0].isIntersecting)}).observe(t);}
  }
  function init(){run();sticky();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
